module.exports = __webpack_public_path__ + "img/lea-41.a0217503.png";